import { render } from "./UserSubjects.vue?vue&type=template&id=5840ce55&scoped=true"
import script from "./UserSubjects.vue?vue&type=script&lang=js"
export * from "./UserSubjects.vue?vue&type=script&lang=js"

import "./UserSubjects.vue?vue&type=style&index=0&id=5840ce55&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5840ce55"]])

export default __exports__